import { makeAutoObservable } from "mobx";
import { getMimeImageType } from "../../utils/fileUtils";

class ModalViewerStore {
  isOpenModal: boolean = false;
  urlModal: string = "";
  documentName: string = "";
  isLocalFileForIframe: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  DownloadFile = (byteArray: number[], fileName: string): void => {
    const uint8Array = new Uint8Array(byteArray);
    const blob = new Blob([uint8Array]);
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  DownloadFileByURL = (Url: string, fileName: string): void => {
    const downloadLink = document.createElement("a");
    downloadLink.href = Url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.target = "_blank";
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  openModal = () => {
    this.isOpenModal = true;
  };

  dissmissModal = () => {
    this.isOpenModal = false;
  };

  editUrlModal = (newUrlModal: string) => {
    this.urlModal = newUrlModal;
  };

  editDocumentName = (newDocumentName: string) => {
    this.documentName = newDocumentName;
  };

  editIsLocalFileForIframe = (status: boolean) => {
    this.isLocalFileForIframe = status;
  };

  openFileByData = (data: any, fileName: string) => {
    const byteArray: number[] = Array.from(atob(data), (char) =>
      char.charCodeAt(0)
    );
    const mimeIsImage = getMimeImageType(fileName);
    const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );
    if (
      mimeIsImage.mimeType.length &&
      (!mimeIsImage.isPdf || (!isMobileDevice && mimeIsImage.isPdf))
    ) {
      const blob = new Blob([new Uint8Array(byteArray)], {
        type: mimeIsImage.mimeType,
      });
      const url = URL.createObjectURL(blob);
      this.editUrlModal(url);
      this.editDocumentName(fileName);
      this.editIsLocalFileForIframe(true);
      this.openModal();
    } else {
      this.DownloadFile(byteArray, fileName);
    }
  };

  openFileByUrl = (url: string, fileName: string) => {
    const mimeIsImage = getMimeImageType(fileName);
    const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );
    if (
      mimeIsImage.mimeType.length &&
      (!mimeIsImage.isPdf || (!isMobileDevice && mimeIsImage.isPdf))
    ) {
      this.editUrlModal(url);
      this.editDocumentName(fileName);
      this.editIsLocalFileForIframe(false);
      this.openModal();
    } else {
      this.DownloadFileByURL(url, fileName);
    }
  };

  openPageByUrl = (url: string, pageName: string) => {
    this.editUrlModal(url);
    this.editDocumentName(pageName);
    this.editIsLocalFileForIframe(false);
    this.openModal();
  };
}
export default ModalViewerStore;
